import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-male",
  "use": "icon-male-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-male\"><g stroke=\"#FFF\" fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#637FE6\" cx=\"12\" cy=\"12\" r=\"11.5\" /><g transform=\"translate(8 5)\" stroke-width=\"2\"><circle cx=\"4\" cy=\"10\" r=\"4\" /><path d=\"M4 1v6M0 3l4-3 4 3\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol